selectionsToResolve